import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationsPage } from "~/pages/Settings/Organisations/OrganisationsPage";

export const Route = createFileRoute("/_app/settings/organisations/")({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.organisations") }],
  }),
  component: OrganisationsPage,
});
